import React from "react";
import { motion } from "framer-motion";
import clientData from "../../assets/data/client-data.json";
import SectionHeading from "../SectionHeading";
import ClientLogoCard from "../Clients/ClientLogoCard";

function Partners() {
  // Select first 6 partners to display
  const partners = clientData.slice(0, 6);

  return (
    <section id="partners" className="scroll-mt-36 py-16 sm:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading eyebrow="Trusted By" title="Our Partners" />
        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-6">
          {partners.map((partner, index) => (
            <motion.li
              key={partner.image}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
            >
              <ClientLogoCard client={partner} />
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Partners;
